import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Brain, ShieldAlert, EyeOff } from 'lucide-react';
export function Problem() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };
  return <section className="py-24 bg-matrix-dark relative overflow-hidden px-4" data-id="element-125">
      <div className="absolute inset-0 opacity-5 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-matrix-green via-transparent to-transparent" data-id="element-126"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-128">
          <h2 className="font-cinzel text-3xl md:text-5xl text-matrix-cream mb-6" data-id="element-129">
            ¿Alguna vez has sentido que algo no encaja?
          </h2>
          <div className="w-24 h-1 bg-matrix-green mx-auto opacity-50" data-id="element-130"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-131">
          <motion.div variants={itemVariants} className="bg-matrix-black border border-matrix-green/20 p-8 rounded-lg hover:border-matrix-green/50 transition-colors duration-300 group" data-id="element-132">
            <div className="bg-matrix-green/10 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-matrix-green/20 transition-colors" data-id="element-133">
              <Brain className="text-matrix-green" size={32} data-id="element-134" />
            </div>
            <p className="text-matrix-white text-lg font-light leading-relaxed" data-id="element-135">
              Vives en piloto automático, repitiendo los mismos patrones sin
              saber por qué.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-matrix-black border border-matrix-green/20 p-8 rounded-lg hover:border-matrix-green/50 transition-colors duration-300 group" data-id="element-136">
            <div className="bg-matrix-green/10 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-matrix-green/20 transition-colors" data-id="element-137">
              <ShieldAlert className="text-matrix-green" size={32} data-id="element-138" />
            </div>
            <p className="text-matrix-white text-lg font-light leading-relaxed" data-id="element-139">
              Sientes que la sociedad te programó para seguir reglas que nunca
              cuestionaste.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-matrix-black border border-matrix-green/20 p-8 rounded-lg hover:border-matrix-green/50 transition-colors duration-300 group" data-id="element-140">
            <div className="bg-matrix-green/10 w-16 h-16 rounded-full flex items-center justify-center mb-6 group-hover:bg-matrix-green/20 transition-colors" data-id="element-141">
              <EyeOff className="text-matrix-green" size={32} data-id="element-142" />
            </div>
            <p className="text-matrix-white text-lg font-light leading-relaxed" data-id="element-143">
              Hay un vacío interior que nada material ha podido llenar.
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="text-center" data-id="element-144">
          <p className="text-2xl md:text-3xl font-cinzel text-matrix-green drop-shadow-[0_0_8px_rgba(0,255,65,0.5)]" data-id="element-145">
            No estás roto. Estás dormido. Y este libro es tu alarma.
          </p>
        </motion.div>
      </div>
    </section>;
}